import { render } from "./RegionMap.vue?vue&type=template&id=af8ffc7e&scoped=true&ts=true"
import script from "./RegionMap.vue?vue&type=script&lang=ts"
export * from "./RegionMap.vue?vue&type=script&lang=ts"

import "./RegionMap.vue?vue&type=style&index=0&id=af8ffc7e&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8ffc7e"]])

export default __exports__